import { Injectable } from "@angular/core";
import { FileLogger, Tools } from "@comunicare/comunicare-helper";
import { AnonymisedDataApiService } from "./api/anonymised-data-api.service";

@Injectable({
  providedIn: "root",
})
export class AnonymisedDataService {
  constructor(private anonymisedDataApiService: AnonymisedDataApiService) {}

  public async export(
    formatExport: "CSV" | "JSON",
    supportCareplans: string,
    exportObs?: string,
    exportQuests?: string,
    emailsToExclude?: string,
    servicesToExclude?: string,
    exportPatients?: boolean,
    exportDrugs?: boolean,
    exportAlert?: boolean,
    anonymisedDate?: boolean,
    careplansWithoutApp?: string,
    healthcareService?: string
  ): Promise<void> {
    try {
      const blob = await this.anonymisedDataApiService
        .export(
          formatExport,
          supportCareplans,
          exportObs,
          exportQuests,
          emailsToExclude,
          servicesToExclude,
          exportPatients,
          exportDrugs,
          exportAlert,
          anonymisedDate,
          careplansWithoutApp,
          healthcareService
        )
        .toPromise();
      if (blob) {
        const url = URL.createObjectURL(blob);
        Tools.downloadBlob(blob, url.split("/")[url.split("/").length - 1]);
      } else {
        FileLogger.error("AnonymisedDataService", "export");
        throw new Error();
      }
    } catch (error) {
      FileLogger.error("AnonymisedDataService", "export", error);
      throw new Error(error.message);
    }
  }
}
